import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import Address from './Address'

const DefaultAddress = ({ address, className, typeOfAddress }) => {
  if (address) {
    return (
      <div className={className}>
        <div className="default-address-heading">Default {typeOfAddress} Address</div>
        <div className="address-box">
          <Address address={address} showDelete={false} />
        </div>
      </div>
    )
  }

  return null
}

DefaultAddress.defaultProps = {
  className: '',
  address: null,
}

DefaultAddress.propTypes = {
  address: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    city: PropTypes.string,
    id: PropTypes.number,
    region: PropTypes.shape({
      region_code: PropTypes.string,
    }),
    country_code: PropTypes.string,
    postcode: PropTypes.string,
    street: PropTypes.arrayOf(PropTypes.string),
    telephone: PropTypes.string,
  }),
  className: PropTypes.string,
  typeOfAddress: PropTypes.string.isRequired,
}

const StyledDefaultAddress = styled(DefaultAddress)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  '.address': {
    paddingBottom: '4px',
  },
  '.address-box': {
    border: `1px solid ${theme.colors.coolGray.cool450}`,
    // use flex-box to stretch child Address vertically, aligning Edit links
    display: 'flex',
    flexGrow: 1,
  },
  '.default-address-heading': {
    color: theme.colors.coolGray.cool600,
    fontStyle: 'italic',
    lineHeight: '22px',
    marginBottom: '5px',
  },
}))

export default StyledDefaultAddress
